// This file contains logic for content pages

/**
 * These can either be defaults for a page or set by the user using search parameters
 */
export type PageState = {
	page: number;
};

/**
 * Normalized mapping for search parameters to state.
 */
export const searchParamsMapping = {
	page: "page",
};

/**
 * Deserializes a page state from a URLSearchParams object.
 */
export const deserializePageState = (params: URLSearchParams): PageState => {
	return {
		page: deserializePage(params),
	};
};

export const deserializePage = (params: URLSearchParams): number =>
	params.has(searchParamsMapping.page)
		? Number.parseInt(params.get(searchParamsMapping.page) as string)
		: 1;
